<template>
  <div>
    <section>
      <div class="columns">
        <div class="column has-text-right">
          <div v-if="crier">
            <button
              v-if="verifySituation(SituacaoEnum.ANALISANDO_PROPOSTAS)"
              class="button field is-primary actions"
              :class="{ ' is-loading': loading.classificarItens }"
              :disabled="!selectedItems.length"
              @click="classificarPropostasItens"
            >
              <span>Classificar</span>
            </button>
          </div>
        </div>
      </div>
    </section>

    <ImportAuctionProposals
      v-if="auctionSituation === SituacaoEnum.ENTREGA_DE_PROPOSTAS"
      @mode="v => (mode = v)"
    />

    <div v-if="!items.length" class="panel">
      <div class="panel-block centered-content">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>{{ emptyItems }}.</p>
          </div>
        </section>
      </div>
    </div>

    <b-table
      hoverable
      class="table is-fullwidth items-table"
      detail-key="id"
      ref="tabela"
      v-if="items.length"
      :data="itemsToShow"
      :checkable="crier && verifySituation(SituacaoEnum.ANALISANDO_PROPOSTAS)"
      :checked-rows.sync="selectedItems"
      :is-row-checkable="row => checkableItems(row)"
      :detailed="detailed"
      :opened-detailed.sync="detailsList"
      @details-open="canSendProposal"
    >
      <b-table-column centered width="60" :visible="exclusiveItem" label="Exclusivo" v-slot="props">
        <b-icon
          custom-size="mdi-24px"
          icon="check"
          type="is-success"
          v-show="props.row.item.exclusivo"
        />
      </b-table-column>

      <b-table-column centered label="ID" width="40" field="identificador" v-slot="props">{{
        props.row.identificador
      }}</b-table-column>

      <b-table-column
        centered
        field="unidade"
        label="Unidade"
        v-slot="props"
        :visible="auctionSituation < SituacaoEnum.LANCES"
        ><div class="unity-column">{{ props.row.unidade.nome }}</div></b-table-column
      >

      <b-table-column
        cell-class="elipsis-size"
        label="Descrição"
        v-slot="props"
        :key="descriptionKey"
        :ref="'description-column'"
      >
        <div
          class="elipsis-column"
          :class="{
            'cursor-pointer': hasDescriptionOverflow(props.row.id),
            'justify-align': justify,
          }"
          :ref="`description-container-${props.row.id}`"
          @click.stop.prevent="openDescription(props.row.id)"
        >
          <b-icon
            class="custom-eye-icon mr-1"
            icon="eye-outline"
            v-if="hasDescriptionOverflow(props.row.id)"
          ></b-icon>

          <a
            :class="{ 'justify-align': justify }"
            :ref="`description-link-${props.row.id}`"
            v-if="hasDescriptionOverflow(props.row.id)"
            >{{ props.row.item.descricao }}</a
          >
          <p v-else>{{ props.row.item.descricao }}</p>
        </div>
      </b-table-column>

      <b-table-column
        :visible="auctionSituation < SituacaoEnum.LANCES"
        centered
        label="Quantidade"
        v-slot="props"
        >{{ props.row.quantidade | formatarNumero }}</b-table-column
      >

      <b-table-column centered label="Referência" v-slot="props" :visible="displayReferralColumn"
        ><div v-if="!props.row.referencia && !props.row.total">
          <b-tag type="is-dark" size="is-small">VIDE EDITAL</b-tag>
        </div>
        <div v-else>{{ formatReference(props.row) | formatarValor }}</div></b-table-column
      >

      <b-table-column :visible="displayTotalReferential" centered label="Total" v-slot="props">
        <div v-if="!props.row.referencia && !props.row.total">
          <b-tag type="is-dark" size="is-small">VIDE EDITAL</b-tag>
        </div>

        <div v-else>{{ displayTotalReferential ? formatarValor(props.row.total) : 0 }}</div>
      </b-table-column>

      <b-table-column centered label="Redução" v-slot="props" :visible="displayReductionColumn"
        ><b-tooltip
          v-if="biggestDiscount && props.row.referencia && props.row.total"
          size="is-medium"
          :label="formatarValor(props.row.reducaoLances)"
          >{{ formatPercentageReduction(props.row) }}</b-tooltip
        >

        <div v-else-if="biggestDiscount">
          {{ formatPercentageReduction(props.row) }}
        </div>

        <div v-else>
          {{ props.row.reducaoLances | formatarValor }}
        </div></b-table-column
      >

      <b-table-column
        centered
        class="lower-bid-column"
        v-slot="props"
        :label="biggestDiscount ? 'Maior Desconto' : 'Menor Lance'"
        :visible="auctionSituation >= SituacaoEnum.LANCES"
      >
        <div class="has-text-centered" :class="{ 'is-flex': mobile, 'justify-end': mobile }">
          <b-tooltip
            v-if="biggestDiscount && props.row.referencia && props.row.total"
            size="is-medium"
            class="discount-tooltip"
            :type="lowerBidColor(props.row)"
            :label="
              props.row.menor_lance.percentual !== null
                ? formatMinorBid(props.row)
                : 'Nenhum Fornecedor'
            "
          >
            <span
              v-if="auctionSituation >= SituacaoEnum.LANCES"
              class="tag tag-extended"
              :class="lowerBidColor(props.row)"
              >{{ formatDiscountPercentage(props.row) }}</span
            >
          </b-tooltip>

          <div v-else>
            <span
              v-if="auctionSituation >= SituacaoEnum.LANCES"
              class="tag tag-extended"
              :class="lowerBidColor(props.row)"
              >{{
                biggestDiscount
                  ? formatDiscountPercentage(props.row)
                  : formatarValor(minorBidExists(props.row))
              }}</span
            >
          </div>

          <b-tooltip
            v-if="biggestDiscount && props.row.referencia && props.row.total"
            size="is-medium"
            type="is-light"
            class="discount-tooltip"
            :label="
              props.row.preferencia.percentual !== null
                ? formatPreferenceBid(props.row)
                : 'Nenhum Fornecedor'
            "
          >
            <span
              class="tag tag-extended"
              v-if="displayPreference(props.row.preferencia.fornecedor)"
              >{{ formatPreferenceDiscount(props.row) }}</span
            >
          </b-tooltip>

          <div v-else>
            <span
              class="tag tag-extended"
              v-if="displayPreference(props.row.preferencia.fornecedor)"
              >{{
                biggestDiscount
                  ? formatPreferenceDiscount(props.row)
                  : formatarValor(preferenceValueExists(props.row))
              }}</span
            >
          </div>
        </div>
      </b-table-column>

      <b-table-column
        centered
        label="Fornecedor"
        :visible="auctionSituation >= SituacaoEnum.LANCES"
        v-slot="props"
      >
        <div class="has-text-centered" :class="{ 'is-flex': mobile, 'justify-end': mobile }">
          <span v-if="!displayCompany" class="tag tag-extended" :class="lowerBidColor(props.row)">{{
            bidderExists(props.row)
          }}</span>
          <span class="tag is-success tag-extended" v-else>{{
            props.row.menor_lance.razao_social
          }}</span>

          <span
            class="tag tag-extended"
            v-if="displayPreference(props.row.preferencia.fornecedor)"
            >{{ preferenceBidExists(props.row) }}</span
          >
        </div>
      </b-table-column>

      <b-table-column centered label="Porte" :visible="displaySizeColumn" v-slot="props">
        <div class="has-text-centered" :class="{ 'is-flex': mobile, 'justify-end': mobile }">
          <div class="company-size-text mr-1">
            {{ formatWinnerCompanySize(props.row) }}
          </div>

          <span class="tag small" v-if="displayPreference(props.row.preferencia.fornecedor)">{{
            preferenceSizeExists(props.row)
          }}</span>
        </div>
      </b-table-column>

      <b-table-column
        centered
        width="120"
        label="Percentual"
        v-slot="props"
        :visible="
          [
            SituacaoEnum.LANCES,
            SituacaoEnum.PREFERENCIA,
            SituacaoEnum.NEGOCIACAO,
            SituacaoEnum.JULGAMENTO,
          ].indexOf(auctionSituation) > -1 &&
          biggestDiscount &&
          !mustReadjustProposals
        "
      >
        <PregaoPercentual
          :ref="`percentual-${props.index}`"
          :item="props.row"
          :lances-fechados-em-envio="closedBidsOnSubmission"
          :valores="bidValues"
          @enviar="informPIN"
          @lance="addBid"
          @aviso="displayPercentageWarning"
        />
      </b-table-column>

      <b-table-column
        :visible="displayValueColumn"
        centered
        width="140"
        v-slot="props"
        :label="bidColumnLabel"
      >
        <template v-if="displayReadjustButton(props.row)">
          <button
            class="button is-primary is-light"
            @click.prevent.stop="viewReadjustProposals(props.row, {})"
          >
            Readequar Proposta
          </button>
        </template>
        <template v-else>
          <PregaoValor
            :ref="`valor-${props.index}`"
            :item="props.row"
            :lances-fechados-em-envio="closedBidsOnSubmission"
            :valores="bidValues"
            @enviar="informPIN"
            @lance="addBid"
            @aviso="displayPercentageWarning"
          />
        </template>
      </b-table-column>

      <b-table-column centered label="Estado" v-slot="props" :visible="displayStatusColumn">
        <span
          v-if="
            company.seller &&
            logged &&
            [SituacaoEnum.ENTREGA_DE_PROPOSTAS, SituacaoEnum.AGUARDANDO_INICIO_SESSAO].includes(
              auctionSituation,
            )
          "
          class="tag tag-extended"
          :class="
            !(itemUiFlags[props.row.id] && itemUiFlags[props.row.id].canSendBatch)
              ? 'is-primary'
              : itemUiFlags[props.row.id] && itemUiFlags[props.row.id].hasProposal
              ? 'is-success'
              : 'is-warning'
          "
        >
          {{
            !(itemUiFlags[props.row.id] && itemUiFlags[props.row.id].canSendBatch)
              ? 'Sem Enquadramento'
              : itemUiFlags[props.row.id] && itemUiFlags[props.row.id].hasProposal
              ? 'Proposta enviada'
              : 'Proposta pendente'
          }}
        </span>
        <span
          v-else
          class="tag is-primary tag-extended"
          :class="props.row.estado | estadoItem(auction.modo_disputa)"
          >{{ props.row.estado | tituloEstadoItem(auction.modo_disputa) }}</span
        >
      </b-table-column>

      <b-table-column centered label="Ações" v-slot="props" :visible="displayActions">
        <button
          class="button is-primary actions"
          @click="sendDocuments(props.row)"
          v-if="displaySendDocuments(props.row)"
        >
          Enviar Documentos
        </button>

        <button
          v-if="auctionSituation === SituacaoEnum.PREFERENCIA && bidder"
          tabindex="-1"
          class="button is-danger is-outlined"
          style="height: 100%"
          :disabled="disable.abdicate"
          @click.stop.prevent="
            verifyPIN(
              props.row.id,
              props.row.identificador,
              props.row.item.descricao,
              props.row.unidade.nome,
            )
          "
        >
          Abdicar Direito
        </button>
      </b-table-column>

      <b-table-column
        centered
        label="Propostas"
        v-slot="props"
        :visible="
          auctionSituation < SituacaoEnum.ANALISANDO_PROPOSTAS &&
          company.id === auction.comprador.id
        "
        >{{ props.row.propostas ? props.row.propostas : 0 }}</b-table-column
      >

      <b-table-column
        centered
        label="Opções"
        v-slot="props"
        :class="{ 'options-column': auctionSituation >= SituacaoEnum.HABILITACAO }"
        :visible="!!displayOptions"
        :width="optionsWidth"
      >
        <b-field
          class="is-justify-content-center"
          v-if="itemUiFlags[props.row.id] && itemUiFlags[props.row.id].proposalIcon"
          id="my-items-options-field"
        >
          <p class="control">
            <button
              v-if="!batchButtonEnabled"
              :disabled="disable.proposalDelete || proposals.length === 0"
              class="button is-primary options-button"
              @click.prevent.stop="editProposal(props.row)"
            >
              <b-icon icon="pencil" size="is-small" />
            </button>
            <button
              v-else-if="
                batchButtonEnabled &&
                itemUiFlags[props.row.id] &&
                !itemUiFlags[props.row.id].showOffers &&
                itemUiFlags[props.row.id].canSendBatch
              "
              class="button is-primary options-button"
              :disabled="disable.proposalDelete"
              @click.prevent.stop="requestBatchProposal(props.row)"
            >
              <span size="is-small">Enviar Proposta</span>
            </button>
          </p>

          <p class="control">
            <button
              :disabled="disable.proposalDelete || proposals.length === 0"
              v-if="
                itemUiFlags[props.row.id] &&
                !itemUiFlags[props.row.id].showOffers &&
                itemUiFlags[props.row.id].canSendBatch
              "
              class="button is-danger options-button"
              @click.prevent.stop="requestProposalDelete(props.row)"
            >
              <b-icon icon="delete" size="is-small" />
            </button>
          </p>
        </b-field>
        <div v-if="hasItemOptionsMenu(props.row)" @click.stop>
          <b-dropdown position="is-bottom-left" class="auction-actions__more" aria-role="list">
            <button
              slot="trigger"
              class="button is-primary is-outlined"
              type="button"
              aria-label="Mais ações"
            >
              <b-icon icon="dots-vertical" size="is-small" />
            </button>

            <b-dropdown-item
              v-if="itemUiFlags[props.row.id] && itemUiFlags[props.row.id].showOffers"
              aria-role="listitem"
              @click="viewOffers(props.row)"
            >
              Ofertas
            </b-dropdown-item>

            <b-dropdown-item
              v-if="itemUiFlags[props.row.id] && itemUiFlags[props.row.id].canDeleteBid"
              aria-role="listitem"
              @click="deleteLastBid(props.row)"
            >
              Excluir
            </b-dropdown-item>

            <b-dropdown-item
              v-if="displayAppealIntentionButton"
              aria-role="listitem"
              :disabled="disableAppealIntentionButton"
              @click="manifestAppealIntention"
            >
              {{ appealIntentionButtonText }}
            </b-dropdown-item>

            <b-dropdown-item
              v-if="displaySendJudgmentDiligence(props.row)"
              aria-role="listitem"
              @click="openJudgmentDiligenceUpload(props.row)"
            >
              Enviar Diligência
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </b-table-column>

      <template v-if="displayFooter" v-slot:footer>
        <div class="footer-container">
          <div class="all-items-button-container has-text-left">
            <button
              class="button is-primary"
              style="height: 100%"
              v-if="displayAllItemsButton"
              @click.stop.prevent="viewAllItems()"
            >
              Todos os Itens
            </button>
          </div>

          <div class="value-warning-container has-text-centered">
            <transition name="fade">
              <b-tag
                v-if="percentageWarning"
                class="value-warning"
                type="is-danger"
                :size="mobile ? 'is-small' : 'is-medium'"
                >{{ percentageWarningText }}</b-tag
              >
            </transition>
          </div>

          <div class="send-button-container has-text-right">
            <button
              v-if="displaySendBidsButton && !mustReadjustProposals"
              ref="sendBidsButton"
              class="button is-primary"
              style="height: 100%"
              :class="{ ' is-loading': loading.general, 'is-small': mobile }"
              @lance="addBid"
              @click.stop.prevent="informPIN"
            >
              {{ sendBidsButtonText }}
            </button>
          </div>
        </div>
      </template>

      <template v-slot:detail="props">
        <SendProposal
          v-if="
            [SituacaoEnum.ENTREGA_DE_PROPOSTAS, SituacaoEnum.AGUARDANDO_INICIO_SESSAO].indexOf(
              auctionSituation,
            ) > -1
          "
          :key="selectProposalKey(props.row.id)"
          :item="props.row"
        />
        <ProposalAnalysis v-if="displayProposalAnalysis" :item="props.row" />
      </template>
    </b-table>
    <div class="columns" v-if="items.length > pagination.perPage">
      <div class="column is-narrow ml-auto">
        <AppPagination
          :has-margin="false"
          :data-filters="{
            page: pagination.page,
            perPage: pagination.perPage,
          }"
          :max-lines="50"
          :total="items.length"
          @change-page="page => changePage({ page })"
          @change-per-page="perPage => changePerPage(perPage)"
        />
      </div>
    </div>

    <b-modal has-modal-card :active.sync="validatingPIN" :onCancel="resetLoadings">
      <PinForm v-if="validatingPIN" :reason="reasonPIN" @validar="deleteAuctionProposal()" />
    </b-modal>

    <b-modal has-modal-card :active.sync="requestProposalPin" :onCancel="cancelProposalPin">
      <PinForm v-if="requestProposalPin" :reason="reasonPIN" @validar="onProposalPinValidated" />
    </b-modal>

    <b-modal
      has-modal-card
      :active.sync="offerConfirmationModal"
      :onCancel="resetLoadings"
      @confirm="sendBids()"
    >
      <AppActionConfirmation
        v-if="displayConfirmation.offer"
        :display="confirmation.offer.display"
        :items="confirmation.offer.items"
        :message="confirmation.offer.message"
        :mobile="mobile"
      />
    </b-modal>

    <b-modal has-modal-card :active.sync="requestPIN" :onCancel="resetLoadings">
      <PinForm v-if="requestPIN" :reason="reasonPIN" @validar="sendBids()" />
    </b-modal>

    <b-modal
      has-modal-card
      :active.sync="preferenceConfirmationModal"
      :onCancel="resetLoadings"
      @confirm="preferenceAbdicate()"
    >
      <AppActionConfirmation
        v-if="displayConfirmation.preference"
        :confirm-type="confirmation.preference.confirmType"
        :iconType="confirmation.preference.iconType"
        :display="confirmation.preference.display"
        :items="confirmation.preference.items"
        :message="confirmation.preference.message"
        :mobile="mobile"
      />
    </b-modal>

    <b-modal has-modal-card :active.sync="preferenceAbdicatePin" :onCancel="resetLoadings">
      <PinForm v-if="preferenceAbdicatePin" :reason="reasonPIN" @validar="preferenceAbdicate()" />
    </b-modal>

    <b-modal
      has-modal-card
      ref="justificationModal"
      :active.sync="justificar"
      :onCancel="resetLoadingClassificacao"
      @justificate="classificarPropostas"
    >
      <AppJustification v-if="justificar" />
    </b-modal>

    <b-modal has-modal-card :active.sync="declarationsModal" :onCancel="cancelDeclarations">
      <DeclarationsModal
        v-if="declarationsModal"
        :showPreference="company.preference && regionalPreferenceEnabled"
        :companySize="company.companySize"
        @confirm="handleDeclarationsConfirm"
        @cancel="cancelDeclarations"
      />
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue';

import { mapActions, mapGetters, mapState } from 'vuex';

import {
  enviarLance,
  enviarPreferencia,
  enviarLanceNegociacao,
  excluirUltimoLance,
} from '@/resources/ofertasCompra';
import {
  verificarPregoeiro,
  verificarFornecedor,
  verificarLicitante,
  getOfertaCompraEnum,
  SituacaoEnum,
} from '@/utils/enumerados';
import { formatarValor } from '@/utils/format';

import auctionItems from '@/mixins/auctionItems';

import AppActionConfirmation from '@/components/AppActionConfirmation';
import AppPagination from '@/components/AppPagination';
import PinForm from '@/views/User/Pin';
import PregaoPercentual from '@/views/Pregao/AuctionContainer/PregaoPercentual';
import PregaoValor from '@/views/Pregao/AuctionContainer/PregaoValor';
import ProposalAnalysis from '@/views/Pregao/AuctionContainer/Proposals/ProposalAnalysis';
import SendProposal from '@/views/Pregao/AuctionContainer/Proposals/SendProposal';

import ImportAuctionProposals from '../Proposals/ImportAuctionProposals';
import AppJustification from '../../../../components/AppJustification';
import DeclarationsModal from '../Proposals/DeclarationsModal';
import { podeExibirBotaoIntencaoRecurso } from '../../../../utils/intencaoRecursoVisibility';

export default {
  name: 'MyItems',
  components: {
    AppActionConfirmation,
    AppPagination,
    AppJustification,
    DeclarationsModal,
    ImportAuctionProposals,
    PinForm,
    PregaoPercentual,
    PregaoValor,
    ProposalAnalysis,
    SendProposal,
  },
  mixins: [auctionItems],
  props: {
    loaded: Boolean,
  },
  data() {
    const data = {
      itemId: 0,
      propostaId: 0,
    };
    const declarations = {
      regionalPreference: false,
    };
    const disable = {
      abdicate: false,
      proposalDelete: false,
    };
    const displayConfirmation = {
      offer: false,
      preference: false,
    };
    const confirmation = {
      offer: {},
      preference: {},
    };
    const loading = {
      classificarItens: false,
    };

    const auctionType = '';
    return {
      auctionType,
      abdicatePreferenceData: {},
      bids: [],
      bidValues: {},
      closedBidsOnSubmission: [],
      componentKey: 0,
      confirmation,
      data,
      descriptionKey: 0,
      declarations,
      declarationsModal: false,
      detailsList: [],
      disable,
      displayConfirmation,
      displayDeleteBidButton: false,
      formatarValor,
      mode: '',
      offerConfirmationModal: false,
      preferenceConfirmationModal: false,
      percentageWarning: false,
      preferenceAbdicatePin: false,
      needReadjustProposals: false,
      justificar: false,
      reasonPIN: '',
      requestPIN: false,
      requestProposalPin: false,
      pendingProposalAction: null,
      validatingPIN: false,
      valuesNegotiationList: [],
      selectedItems: [],
      loading,
      pendingSendBids: false,
      declarationsModalShown: false,
      pagination: {
        page: 1,
        perPage: 20,
      },
      deleteBidNow: Date.now(),
      deleteBidTimer: null,
      descriptionOverflowById: {},
      descriptionOverflowTimeout: null,
      manifestAppealLoading: false,
      SituacaoEnum,
    };
  },
  watch: {
    auctionSituation(situation, previousSituation) {
      this.fetchAppealIntention(previousSituation);
      this.refreshJudgmentDiligences();
    },
    'auction.id': function watchAuctionId() {
      this.fetchAppealIntention();
    },
    auctionDeclarations: {
      immediate: true,
      handler() {
        this.declarations.regionalPreference = this.auctionDeclarations.some(
          element => element.declaration === 'PREFERENCIA-REGIONAL',
        );
      },
    },
    loaded() {
      if (this.loaded) {
        this.refreshDescriptionOverflow();
      }
    },
    items() {
      const totalPages = Math.max(1, Math.ceil(this.items.length / this.pagination.perPage));
      if (this.pagination.page > totalPages) {
        this.pagination.page = totalPages;
      }
      this.refreshDescriptionOverflow();
    },
    itemsToShow() {
      this.refreshDescriptionOverflow();
      this.syncDeleteBidTimer();
    },
    bidsByItemTimestamp: {
      immediate: true,
      handler() {
        this.syncDeleteBidTimer();
      },
    },
    'userLoggedBidder.excluiuLance': function onUserLoggedBidderExcluiuLance() {
      this.syncDeleteBidTimer();
    },
  },
  proposals: {
    deep: true,
    handler() {
      if (this.mode === 'import') this.componentKey += 1;
    },
  },
  computed: {
    ...mapState('app', ['windowWidth']),
    ...mapState('auctionsBidders', ['userLoggedBidder']),
    ...mapState('companies', ['company']),
    ...mapState('proposals', ['readjustedProposals']),
    ...mapState('companyBilling', ['status', 'currentBillingMethodId', 'companyCredits']),
    ...mapGetters('companyBilling', ['hasBillingWarning']),
    ...mapGetters({
      allItems: 'obterTodosItens',
      auctionBids: 'obterOfertaCompraLances',
      filteredItems: 'obterItens',
      user: 'getUser',
      function: 'getFunction',
      validPin: 'getValidPin',
      hasAppealIntention: 'verificarOfertaCompraIntencaoRecursoManifestada',
      prazoManifestacaoIntencao: 'obterPrazoManifestacaoIntencao',
    }),
    ...mapGetters({
      logged: 'getLogged',
    }),
    ...mapGetters('auctionsDeclarations', {
      auctionDeclarations: 'getDeclarations',
      auctionDeclarationsLoaded: 'getDeclarationsLoaded',
    }),
    ...mapGetters('proposals', { proposals: 'obterPropostasUsuarioLogado' }),
    ...mapGetters('judgmentDiligences', {
      activeDiligenceForItemBidder: 'activeDiligenceForItemBidder',
    }),
    batchButtonEnabled() {
      return this.allItems.some(({ item }) => item.tipo === 'LOT') && !this.biggestDiscount;
    },
    bidsByItemTimestamp() {
      const bidsByItem = {};
      const supplierId = this.userLoggedBidder && this.userLoggedBidder.id;
      if (!supplierId) {
        return bidsByItem;
      }

      this.auctionBids.forEach(oferta => {
        if (oferta.fornecedor_id !== supplierId) {
          return;
        }
        const parsedDate = new Date(oferta.dataLance).getTime();
        if (Number.isNaN(parsedDate)) {
          return;
        }

        const currentTimestamp = bidsByItem[oferta.ofertaCompraItemId];
        if (!currentTimestamp || parsedDate > currentTimestamp) {
          bidsByItem[oferta.ofertaCompraItemId] = parsedDate;
        }
      });

      return bidsByItem;
    },
    itemUiFlags() {
      const now = this.deleteBidNow;
      const disableDelete = !!(this.userLoggedBidder && this.userLoggedBidder.excluiuLance);
      const isBidSituation = [SituacaoEnum.LANCES, SituacaoEnum.PREFERENCIA].includes(
        this.auctionSituation,
      );

      return this.itemsToShow.reduce((accumulator, row) => {
        const latestTimestamp = this.bidsByItemTimestamp[row.id];
        const canDeleteBid =
          !disableDelete && !!latestTimestamp && latestTimestamp > now - 15000 && isBidSituation;
        const canSendBatch = this.canSendBatchProposal(row);
        const showOffers = this.displayOffersListByState(row.estado);

        return {
          ...accumulator,
          [row.id]: {
            canDeleteBid,
            canSendBatch,
            hasProposal: this.hasProposal(row.id),
            proposalIcon: this.batchButtonEnabled || this.proposalIcon(row),
            showOffers,
          },
        };
      }, {});
    },
    mustReadjustProposals() {
      return this.items.some(item => this.displayReadjustButton(item));
    },
    allClosedSent() {
      const closedBidItemIds = new Set(
        this.auctionBids
          .filter(lance => lance.tipo === 'FECHADO')
          .map(lance => lance.ofertaCompraItemId),
      );
      return this.filteredItems.every(item => closedBidItemIds.has(item.id));
    },
    bidColumnLabel() {
      if (this.auctionSituation === SituacaoEnum.NEGOCIACAO) return 'Proposta';
      if (
        [SituacaoEnum.LANCES, SituacaoEnum.PREFERENCIA].indexOf(this.auctionSituation) > -1 &&
        this.auction.tipo_negociacao.id === 1
      ) {
        return 'Valor Unitário';
      }
      return 'Valor Total';
    },
    closedMode() {
      return this.items.some(
        item => ['LANCE-FECHADO', 'PRIMEIRA-CHAMADA', 'NOVA-CHAMADA'].indexOf(item.estado) > -1,
      );
    },
    detailed() {
      if (this.isSineDieFromEntregaDePropostas) return false;
      if (this.company.status !== 'HABILITADA' && !this.bidder) return false;
      if (
        this.allItems.some(({ item }) => item.tipo === 'LOT') &&
        this.company.seller &&
        !this.biggestDiscount
      ) {
        return false;
      }
      if (!this.operateAuctions) return false;
      return (
        [SituacaoEnum.ENTREGA_DE_PROPOSTAS, SituacaoEnum.AGUARDANDO_INICIO_SESSAO].indexOf(
          this.auctionSituation,
        ) > -1 ||
        (this.auctionSituation === SituacaoEnum.ANALISANDO_PROPOSTAS &&
          this.auction.comprador.id === this.company.id) ||
        (this.allItems.some(({ item }) => item.tipo === 'LOT') &&
          !this.company.seller &&
          !this.biggestDiscount)
      );
    },
    displayProposalAnalysis() {
      return (
        this.auctionSituation === SituacaoEnum.ANALISANDO_PROPOSTAS &&
        this.auction.comprador.id === this.company.id
      );
    },
    disableRequirementsDeclaration() {
      return this.proposals.length > 0 || this.hasBillingWarning;
    },
    showBillingWarning() {
      return this.hasBillingWarning && this.proposals.length === 0;
    },
    displayActions() {
      return (
        (this.auctionSituation === SituacaoEnum.PREFERENCIA && this.bidder) ||
        ([SituacaoEnum.NEGOCIACAO, SituacaoEnum.HABILITACAO].includes(this.auctionSituation) &&
          this.crier) ||
        (this.auctionSituation === SituacaoEnum.HABILITACAO &&
          this.bidder &&
          this.items.some(item => this.canSendQualificationDocuments(item)))
      );
    },
    displayAllItemsButton() {
      return (
        [
          SituacaoEnum.LANCES,
          SituacaoEnum.PREFERENCIA,
          SituacaoEnum.NEGOCIACAO,
          SituacaoEnum.HABILITACAO,
        ].indexOf(this.auctionSituation) > -1 &&
        this.bidder &&
        this.filteredItems.length < this.allItems.length
      );
    },
    displayOptions() {
      const situation = this.auctionSituation;

      const hasProposalsInSubmissionStage =
        situation === SituacaoEnum.ENTREGA_DE_PROPOSTAS && this.proposals.length > 0;

      const isJudgmentStage = situation === SituacaoEnum.JULGAMENTO;

      const isBetweenAnalysisAndPriceAdhesion =
        situation > SituacaoEnum.ANALISANDO_PROPOSTAS && situation < SituacaoEnum.FRACASSADA;

      const isLotSellerWithoutBiggestDiscount =
        this.allItems.some(({ item }) => item.tipo === 'LOT') &&
        this.company.seller &&
        !this.biggestDiscount;

      return (
        hasProposalsInSubmissionStage ||
        isBetweenAnalysisAndPriceAdhesion ||
        isLotSellerWithoutBiggestDiscount ||
        isJudgmentStage
      );
    },
    displaySendBidsButton() {
      return (
        [SituacaoEnum.PREFERENCIA, SituacaoEnum.NEGOCIACAO, SituacaoEnum.JULGAMENTO].indexOf(
          this.auctionSituation,
        ) > -1 ||
        (this.auctionSituation === SituacaoEnum.LANCES && !this.allClosedSent)
      );
    },
    displayTerms() {
      return (
        this.auctionSituation === SituacaoEnum.ENTREGA_DE_PROPOSTAS &&
        this.company.status === 'HABILITADA' &&
        (this.provider || this.bidder) &&
        this.auctionDeclarationsLoaded
      );
    },
    displayTotalReferential() {
      return (
        this.authorizedBuyer &&
        this.auctionSituation === SituacaoEnum.ANALISANDO_PROPOSTAS &&
        this.negotiationType === 1
      );
    },
    displayValueColumn() {
      if (this.mustReadjustProposals) {
        return true;
      }

      if (
        [
          SituacaoEnum.LANCES,
          SituacaoEnum.PREFERENCIA,
          SituacaoEnum.NEGOCIACAO,
          SituacaoEnum.JULGAMENTO,
        ].indexOf(this.auctionSituation) > -1
      ) {
        if (this.biggestDiscount) {
          const itemReferential = this.filteredItems.some(item => item.total && item.referencia);

          if (!itemReferential) return false;
        }

        return true;
      }
      return false;
    },
    emptyItems() {
      switch (this.auctionSituation) {
        case SituacaoEnum.LANCES:
          return 'Você não tem itens para enviar lance';
        case SituacaoEnum.PREFERENCIA:
          return 'Você não tem itens para exercer preferência';
        default:
          return 'Aguarde o pregoeiro iniciar a próxima etapa do pregão eletrônico';
      }
    },
    getReasonPIN() {
      return {
        [SituacaoEnum.LANCES]: 'PREGAO-LANCE',
        [SituacaoEnum.PREFERENCIA]: 'PREGAO-PREFERENCIA',
        [SituacaoEnum.NEGOCIACAO]: 'PREGAO-NEGOCIACAO',
        [SituacaoEnum.JULGAMENTO]: 'PREGAO-NEGOCIACAO',
      }[this.auctionSituation];
    },
    items() {
      if (
        verificarFornecedor(this.function) ||
        (verificarLicitante(this.function) &&
          [SituacaoEnum.ENTREGA_DE_PROPOSTAS, SituacaoEnum.AGUARDANDO_INICIO_SESSAO].indexOf(
            this.auctionSituation,
          ) > -1)
      ) {
        return this.allItems;
      }

      if (
        verificarPregoeiro(this.function) &&
        this.auctionSituation === SituacaoEnum.ANALISANDO_PROPOSTAS
      ) {
        return this.allItems;
      }

      return this.filteredItems;
    },
    itemsToShow() {
      return this.items.slice(
        (this.pagination.page - 1) * this.pagination.perPage,
        this.pagination.page * this.pagination.perPage,
      );
    },
    openItem() {
      return this.items.some(
        item =>
          [
            'LANCE',
            'LANCE-RANDOMICO',
            'LANCE-FECHADO',
            'PREFERENCIA-INICIADA',
            'NEGOCIACAO',
            'JULGAMENTO',
          ].indexOf(item.estado) > -1,
      );
    },
    operateAuctions() {
      return this.user.empresas.some(
        userCompany => userCompany.id === this.company.id && userCompany.operar_pregoes,
      );
    },
    optionsWidth() {
      if (this.auctionSituation >= SituacaoEnum.HABILITACAO && this.bidder) return '120';
      return '110';
    },
    percentageWarningText() {
      if (this.biggestDiscount) return '20% maior que o maior desconto';
      return '20% menor que o menor lance';
    },
    sendBidsButtonText() {
      if (this.auctionSituation === SituacaoEnum.LANCES) {
        return 'Enviar Lance(s)';
      }
      if (this.auctionSituation === SituacaoEnum.PREFERENCIA) {
        return 'Enviar Preferência(s)';
      }
      if (
        this.auctionSituation === SituacaoEnum.NEGOCIACAO ||
        this.auctionSituation === SituacaoEnum.JULGAMENTO
      ) {
        return 'Enviar Proposta(s)';
      }
      return 'ERROR';
    },
    displayAppealIntentionButton() {
      return podeExibirBotaoIntencaoRecurso({
        auction: this.auction,
        situacao: this.auctionSituation,
        prazoManifestacao: this.prazoManifestacaoIntencao,
        isBidder: this.bidder,
      });
    },
    appealIntentionButtonText() {
      return this.hasAppealIntention
        ? 'Intenção de recurso registrada'
        : 'Manifestar Intenção de Recurso';
    },
    disableAppealIntentionButton() {
      return this.manifestAppealLoading || this.hasAppealIntention;
    },
    suspendedJudgment() {
      return (
        this.auctionSituation === SituacaoEnum.SUSPENSA &&
        this.deadlines &&
        this.deadlines[this.deadlines.length - 2]?.prazo_id === 19
      );
    },
    displayJudgmentDiligenceStage() {
      return this.verifySituation(SituacaoEnum.JULGAMENTO) || this.suspendedJudgment;
    },
  },
  sockets: {
    'auction:judgment-diligences': function updateJudgmentDiligences(diligences) {
      this.updateJudgmentDiligences(diligences);
      this.refreshJudgmentDiligences();
    },
    'pregao:lance-processado': function updateCompanyBidsAuction(bid) {
      if (this.bidder && this.userLoggedBidder.alias === bid.fornecedor) {
        if (bid.status === 'INVALIDO') {
          if (this.auctionSituation === SituacaoEnum.LANCES && !this.closedMode) {
            this.$alerta(`Lance Inválido no Item ${bid.identificador}`, 'is-danger', 3000);
          } else if (this.auctionSituation === SituacaoEnum.PREFERENCIA) {
            this.$alerta(`Preferência Inválida no Item ${bid.identificador}`, 'is-danger', 3000);
          }
        }

        if (bid.tipo === 'FECHADO') {
          const index = this.closedBidsOnSubmission.findIndex(
            elemento => elemento.ofertaCompraItemId === bid.ofertaCompraItemId,
          );

          if (index > -1) {
            this.closedBidsOnSubmission.splice(index, 1);
          }
        }
        this.atualizarLancesItemEmpresa(bid);
      }
    },
  },
  methods: {
    ...mapActions([
      'invalidatePin',
      'adicionarLancesEmpresa',
      'atualizarLancesItemEmpresa',
      'excluirUltimoLanceEmpresa',
      'buscarOfertaCompraIntencaoRecurso',
      'sincronizarIntencaoRecursoPorSituacao',
      'manifestarOfertaCompraIntencaoRecurso',
    ]),
    ...mapActions('companyBilling', ['getCompanyCredits', 'getCompanyCurrentBillingMethod']),
    ...mapActions('auctionsDeclarations', ['createAuctionDeclaration', 'removeAuctionDeclaration']),
    ...mapActions('proposals', ['classificarItens', 'deleteProposal']),
    ...mapActions('auctionsBidders', ['fetchUserLoggedBidder']),
    ...mapActions('judgmentDiligences', [
      'fetchJudgmentDiligences',
      'fetchUnresolvedJudgmentDiligences',
      'updateJudgmentDiligences',
    ]),
    changePage({ page }) {
      this.pagination.page = page;
      this.syncDetailRows();
    },
    changePerPage(perPage) {
      this.pagination.page =
        Number(perPage) > Number(this.pagination.perPage) ? 1 : this.pagination.page;
      this.pagination.perPage = perPage;
      this.syncDetailRows();
    },
    async fetchAppealIntention(situacaoAnterior) {
      if (!this.auction.id || !this.bidder) {
        return;
      }
      try {
        await this.sincronizarIntencaoRecursoPorSituacao({
          situacaoAnterior,
          situacaoAtual: this.auctionSituation,
          ofertaCompraId: this.auction.id,
        });
      } catch (error) {
        this.$alerta(error.message, 'is-danger');
      }
    },
    async manifestAppealIntention() {
      if (this.hasAppealIntention) {
        return;
      }
      this.manifestAppealLoading = true;
      try {
        await this.manifestarOfertaCompraIntencaoRecurso();
        this.$alerta('Intenção de recurso manifestada com sucesso', 'is-success');
      } catch (error) {
        this.$alerta(error.message, 'is-danger');
      } finally {
        this.manifestAppealLoading = false;
      }
    },
    async deleteLastBid(row) {
      const proceed = await this.$confirmacao({
        message:
          'Essa ação irá excluir o último lance do item no pregão eletrônico. Deseja prosseguir?',
        cancelText: 'Cancelar',
        confirmText: 'Continuar',
        type: 'is-danger',
        hasIcon: true,
      });
      if (!proceed) {
        return;
      }
      try {
        await excluirUltimoLance({
          ofertaCompraId: this.auction.id,
          itemId: row.id,
        });
        this.$alerta('O último lance foi excluido', 'is-success');
        this.fetchUserLoggedBidder(this.$route.params.id);
        this.excluirUltimoLanceEmpresa({ itemId: row.id, supplierId: this.userLoggedBidder.id });
      } catch (error) {
        this.$alerta('Erro ao excluir último lance', 'is-danger');
      }
    },
    addBid(bid) {
      const cloneBid = { ...bid };

      this.bidValues = cloneBid.valores;
      delete cloneBid.valores;

      if (!this.bids.length) {
        this.bids.push(cloneBid);
      } else {
        const index = this.bids.findIndex(
          lanceParaEnviar => lanceParaEnviar.ofertaCompraItemId === bid.ofertaCompraItemId,
        );

        if (index === -1) {
          this.bids.push(cloneBid);
        } else {
          Vue.set(this.bids, index, cloneBid);
        }
      }
    },
    allowBidDelete(row) {
      if (this.userLoggedBidder.excluiuLance) {
        return false;
      }
      const dataUltimoLance = this.bidsByItemTimestamp[row.id];
      if (!dataUltimoLance) {
        return false;
      }
      return dataUltimoLance > Date.now() - 15000;
    },
    displayOffersListByState(estado) {
      return (
        this.auctionSituation > SituacaoEnum.AGUARDANDO_INICIO_SESSAO &&
        this.auctionSituation <= SituacaoEnum.JULGAMENTO &&
        this.auctionSituation !== SituacaoEnum.DESERTA &&
        estado !== 'DESERTO'
      );
    },
    bidderExists(item) {
      return item.menor_lance.fornecedor ? item.menor_lance.fornecedor : 'Nenhum fornecedor';
    },
    canSendProposal(row) {
      if (this.isSineDieFromEntregaDePropostas) {
        this.$refs.tabela.closeDetailRow(row);
        return;
      }
      if (
        ![
          'CADASTRADA',
          'LANCE-ENCERRADA',
          'NEGOCIACAO',
          'JULGAMENTO',
          'HABILITACAO-ENCERRADA',
        ].includes(row.estado)
      ) {
        this.$refs.tabela.closeDetailRow(row);
        return;
      }
      if (
        this.auctionSituation === SituacaoEnum.ENTREGA_DE_PROPOSTAS &&
        row.item.exclusivo &&
        !this.company.preference
      ) {
        this.$refs.tabela.closeDetailRow(row);
        this.$alerta('Item exclusivo para empresa de porte com preferência', 'is-danger', 4000);
        return;
      }
      if (this.company.status !== 'HABILITADA' && !this.bidder) {
        this.$refs.tabela.closeDetailRow(row);
        this.$alerta('Entre em seu perfil e solicite validação da empresa', 'is-danger', 4000);
        return;
      }
      if (this.shouldAskPinToInsertProposal(row)) {
        this.$refs.tabela.closeDetailRow(row);
        this.requestProposalAccess('detail', row, 'PREGAO-CRIAR-PROPOSTA');
      }
    },
    shouldAskPinToInsertProposal(row) {
      if (this.validPin || this.hasProposal(row.id)) {
        return false;
      }
      return (
        [SituacaoEnum.ENTREGA_DE_PROPOSTAS, SituacaoEnum.AGUARDANDO_INICIO_SESSAO].indexOf(
          this.auctionSituation,
        ) > -1
      );
    },
    requestProposalAccess(type, row, reason) {
      if (this.validPin) {
        this.continueProposalAccess(type, row);
        return;
      }
      this.pendingProposalAction = { type, row };
      this.reasonPIN = reason;
      this.requestProposalPin = true;
    },
    requestBatchProposal(row) {
      const reason = this.hasProposal(row.id)
        ? 'PREGAO-ATUALIZAR-PROPOSTA'
        : 'PREGAO-CRIAR-PROPOSTA';
      this.requestProposalAccess('batch', row, reason);
    },
    async continueProposalAccess(type, row) {
      if (type === 'batch') {
        this.viewBatchOffers(row);
        return;
      }
      if (type === 'detail') {
        if (!this.detailsList.some(itemId => itemId === row.id)) {
          this.detailsList.push(row.id);
        }
        return;
      }
      if (type === 'edit') {
        await this.openProposalEditor(row);
      }
    },
    async openProposalEditor(row) {
      if (!this.detailsList.some(itemLista => itemLista === row.id)) {
        this.detailsList.push(row.id);
      }
      this.$emitBus('editar', row.id);
    },
    onProposalPinValidated() {
      this.requestProposalPin = false;
      const pending = this.pendingProposalAction;
      this.pendingProposalAction = null;
      if (pending && pending.row) {
        this.continueProposalAccess(pending.type, pending.row);
      }
    },
    cancelProposalPin() {
      this.requestProposalPin = false;
      this.pendingProposalAction = null;
    },
    canSendBatchProposal(row) {
      if (this.isSineDieFromEntregaDePropostas) return false;
      if (!['CADASTRADA', 'LANCE-ENCERRADA', 'NEGOCIACAO', 'JULGAMENTO'].includes(row.estado)) {
        return false;
      }
      if (
        this.auctionSituation === SituacaoEnum.ENTREGA_DE_PROPOSTAS &&
        row.item.exclusivo &&
        !this.company.preference
      ) {
        return false;
      }
      if (this.company.status !== 'HABILITADA' && !this.bidder) {
        return false;
      }
      return true;
    },
    cleanFields() {
      this.percentageWarning = false;
      this.$emitBus('limparCampos');
    },
    hasProposal(id) {
      return this.proposals.some(proposal => proposal.oferta_compra_item_id === id);
    },
    async createDeclaration(declarationType, declarationValue) {
      try {
        if (declarationValue) {
          await this.createAuctionDeclaration({
            auctionId: this.auction.id,
            companyId: this.company.id,
            type: declarationType,
            value: declarationValue,
          });
        } else {
          const declaration = this.auctionDeclarations.find(
            element => element.declaration === declarationType,
          );

          if (declaration) {
            await this.removeAuctionDeclaration({
              auctionId: this.auction.id,
              companyId: this.company.id,
              declarationId: declaration.id,
            });
          }
        }
      } catch (error) {
        if (error && error.response) {
          const { data } = error.response;
          if (data.error === 'ValidationError' && data.details.message === 'Fora do prazo') {
            this.$alerta(data.details.message, 'is-danger');
            return;
          }
        }

        this.$alerta(
          declarationValue ? 'Erro ao aceitar declaração' : 'Erro ao remover declaração',
          'is-danger',
        );
      }
    },
    async deleteAuctionProposal() {
      this.mode = 'delete';

      if (this.validPin) {
        const itemProposal = this.proposals.find(
          proposta => proposta.oferta_compra_item_id === this.data.itemId,
        );
        if (itemProposal) this.data.propostaId = itemProposal.id;

        this.disable.proposalDelete = true;
        try {
          await this.deleteProposal({
            auctionItemId: this.data.itemId,
            proposalId: this.data.propostaId,
          });
          this.$alerta('Proposta excluída', 'is-success');
          this.componentKey += 1;
        } catch (error) {
          const resposta = error.response.data;
          if (resposta.error.type === 'ForaDoPrazo') {
            this.$alerta('Fora do prazo', 'is-danger');
          } else {
            this.$alerta('Erro ao excluir proposta', 'is-danger');
          }
        }
        this.mode = '';
        this.validatingPIN = false;
        this.invalidatePin(false);
        this.disable.proposalDelete = false;
      }
    },
    displayPercentageWarning(booleano) {
      if (this.auctionSituation === SituacaoEnum.LANCES) this.percentageWarning = booleano;
    },
    displayReadjustButton(item) {
      return (
        item.item.tipo === 'LOT' &&
        [SituacaoEnum.NEGOCIACAO, SituacaoEnum.JULGAMENTO].includes(this.auctionSituation)
      );
    },
    displaySendDocuments(item) {
      return (
        (this.auctionSituation === SituacaoEnum.HABILITACAO && this.crier) ||
        (this.auctionSituation === SituacaoEnum.HABILITACAO &&
          this.bidder &&
          this.canSendQualificationDocuments(item))
      );
    },
    canSendQualificationDocuments(item) {
      if (!item || item.estado !== 'HABILITACAO' || !this.userLoggedBidder) {
        return false;
      }

      // Só Habilitação NORMAL + inversão: todos com oferta no item.
      // Habilitação da adesão (sem inversão) segue a regra legada em Todos os Itens.
      if (this.auction?.phase_inversion && !this.adherenceStep) {
        const hasValidBid = this.auctionBids.some(
          bid =>
            bid.ofertaCompraItemId === item.id &&
            bid.fornecedor_id === this.userLoggedBidder.id &&
            bid.status === 'VALIDO',
        );
        if (hasValidBid) return true;

        return this.proposals.some(
          proposal =>
            proposal.oferta_compra_item_id === item.id &&
            (proposal.fornecedor === this.userLoggedBidder.alias ||
              proposal.fornecedor_id === this.userLoggedBidder.id),
        );
      }

      return item.menor_lance?.fornecedor === this.userLoggedBidder.alias;
    },
    editProposal(row) {
      this.requestProposalAccess('edit', row, 'PREGAO-ATUALIZAR-PROPOSTA');
    },
    focusValueInput() {
      if (
        [
          SituacaoEnum.LANCES,
          SituacaoEnum.PREFERENCIA,
          SituacaoEnum.NEGOCIACAO,
          SituacaoEnum.JULGAMENTO,
        ].indexOf(this.auctionSituation) > -1
      ) {
        if (this.closedMode) {
          let reference;
          this.items.forEach((elemento, indice) => {
            const valor = `${this.biggestDiscount ? 'percentual' : 'valor'}-${indice}`;
            if (Object.prototype.hasOwnProperty.call(this.$refs, valor)) {
              if (this.$refs[valor].exibirCampoLanceFechado && !reference) reference = valor;
            }
          });
          if (reference) {
            setTimeout(() => {
              this.$refs[reference].focus();
            }, 100);
          }
        } else {
          setTimeout(() => {
            this.$refs[`${this.biggestDiscount ? 'percentual-0' : 'valor-0'}`].focus();
          }, 100);
        }
      }
    },
    informPIN() {
      this.$nextTick(() => {
        if (this.$refs.sendBidsButton !== undefined) this.$refs.sendBidsButton.focus();
      });

      const greaterThanZero = this.bids.some(lance => lance.percentual || lance.valor);
      const invalidBid = this.bids.some(lance => lance.invalido);
      const validBid = this.bids.some(lance => !lance.invalido);

      if (!this.bids.length || !greaterThanZero) {
        this.$alerta('Nenhum lance inserido', 'is-danger', 3000);
        this.focusValueInput();
        return;
      }

      if (invalidBid && !validBid) {
        this.$alerta('Existe valor inválido', 'is-danger', 3000);
        this.focusValueInput();
        return;
      }

      if (this.bids.length) {
        this.bids = this.bids
          .filter(lance => (this.biggestDiscount ? lance.percentual : lance.valor))
          .sort((a, b) => a.identificador - b.identificador);

        const bidAboveLimite = this.bids.find(lance => lance.valor > 999999999.9999);

        if (bidAboveLimite) {
          this.$alerta('Valor acima do limite: R$ 999.999.999,9999', 'is-danger', 4000);
          this.focusValueInput();
          return;
        }

        this.resetState();

        this.offerConfirmationModal = true;

        this.mountOfferConfirmation();
      }
    },
    mountOfferConfirmation() {
      this.confirmation.offer.display = {
        identifier: true,
        description: true,
        unity: true,
        brand: false,
        imported: false,
        percent: this.biggestDiscount,
        value: true,
      };

      this.confirmation.offer.message = {
        6: 'Confirme o(s) lance(s):',
        7: 'Confirme a(s) preferência(s)',
        8: 'Confirme a(s) oferta(s)',
        19: 'Confirme a(s) oferta(s)',
      }[this.auctionSituation];

      this.confirmation.offer.items = this.bids.map(bid => ({
        identifier: bid.identificador,
        description: bid.descricao,
        unity: bid.unidadeNome,
        percent: this.biggestDiscount ? bid.percentual : null,
        value: bid.valor,
      }));

      this.requestPIN = false;
      this.displayConfirmation.offer = true;
      this.offerConfirmationModal = true;
    },
    mountPreferenceConfirmation() {
      this.confirmation.preference.display = {
        identifier: true,
        description: true,
        unity: true,
        brand: false,
        imported: false,
        percent: false,
        value: false,
      };

      this.confirmation.preference.message =
        'Você está abdicando do direito de preferência para o Item:';
      this.confirmation.preference.iconType = 'is-danger';
      this.confirmation.preference.confirmType = 'is-danger';

      this.confirmation.preference.items = [];
      this.confirmation.preference.items.push({
        identifier: this.abdicatePreferenceData.itemIdentifier,
        description: this.abdicatePreferenceData.itemDescription,
        unity: this.abdicatePreferenceData.itemUnity,
        percent: null,
      });

      this.preferenceAbdicatePin = false;
      this.displayConfirmation.preference = true;
      this.preferenceConfirmationModal = true;
    },
    openDetails(row) {
      if ((this.company.status !== 'HABILITADA' && !this.bidder) || row.estado === 'REVOGADO') {
        return;
      }
      if (this.auctionSituation === 3 && row.item.exclusivo && !this.company.preference) {
        this.$alerta('Item exclusivo para empresas de porte com preferência', 'is-danger', 4000);
        return;
      }
      if (this.detailsList.length) {
        const openItem = this.detailsList.findIndex(itemLista => itemLista === row.id);
        if (openItem > -1) {
          this.detailsList.splice(openItem, 1);
          return;
        }
      }
      this.detailsList.push(row.id);
    },
    hasDescriptionOverflow(itemId) {
      return !!this.descriptionOverflowById[itemId];
    },
    async preferenceAbdicate() {
      if (!this.validPin) {
        this.displayConfirmation.preference = false;
        this.requestPIN = true;
        this.reasonPIN = this.getReasonPIN;
        return;
      }

      this.loading.confirm = true;
      this.disable.abdicate = true;
      try {
        await this.abdicarPreferencia(this.abdicatePreferenceData.itemId);
        this.$alerta('Direito de preferência abdicado', 'is-success', 3000);
      } catch (error) {
        this.$alerta('Não foi possível abdicar do direito de preferência', 'is-danger', 3000);
      } finally {
        this.loading.confirm = false;
        this.disable.abdicate = false;
      }
    },
    proposalIcon(row) {
      if (this.displayBatchButton()) {
        return true;
      }
      if (this.auctionSituation !== 3 || row.estado === 'REVOGADO') return false;
      return this.proposals.find(proposal => proposal.oferta_compra_item_id === row.id);
    },
    async requestProposalDelete(row) {
      this.data.itemId = row.id;
      const type = getOfertaCompraEnum(this.auction.tipo).titleSingular;
      const proceed = await this.$confirmacao({
        message: `Essa ação irá excluir a proposta do item no(a) ${type}. Deseja prosseguir?`,
        cancelText: 'Cancelar',
        confirmText: 'Continuar',
        type: 'is-danger',
        hasIcon: true,
      });
      if (!proceed) {
        return;
      }

      this.validatingPIN = true;
      this.reasonPIN = 'PREGAO-EXCLUIR-PROPOSTA';
    },
    resetLoadings() {
      this.loading.general = false;
    },
    resetLoadingClassificacao() {
      this.loading.classificarItens = false;
    },
    resetState() {
      this.$emitBus('resetarEstado');
    },
    async sendBids() {
      if (!this.validPin) {
        this.displayConfirmation.offer = false;
        this.requestPIN = true;
        this.reasonPIN = this.getReasonPIN;
        return;
      }

      if (this.proposals.length === 0 && !this.declarationsModalShown) {
        this.displayConfirmation.offer = false;
        this.pendingSendBids = true;
        this.declarationsModal = true;
        return;
      }

      await this.executeSendBids();
    },
    async executeSendBids() {
      const mappedBids = this.bids.map(bid => {
        const cloneBid = { ...bid };
        if (this.biggestDiscount) {
          delete cloneBid.valor;
        } else {
          delete cloneBid.percentual;
        }

        return cloneBid;
      });

      this.loading.general = true;
      if (this.auctionSituation === SituacaoEnum.LANCES) {
        if (this.closedMode) {
          this.closedBidsOnSubmission = [...mappedBids];
        }
        await enviarLance(this.auction.id, mappedBids)
          .then(data => {
            if (data.data.length === 1) {
              this.$alerta('Lance Enviado', 'is-info', 1000);
            } else if (data.data.length > 1) {
              this.$alerta('Lances Enviados', 'is-info', 1000);
            }
            this.adicionarLancesEmpresa(data.data);
            if (this.openItem) this.focusValueInput();
          })
          .catch(error => {
            if (error.response && Array.isArray(error.response.data.error)) {
              const outOfTime = error.response.data.error.some(
                element => element.status === 'ForaDoPrazo',
              );

              if (outOfTime) {
                this.$alerta('Tempo finalizado', 'is-danger');
                return;
              }
            }
            this.$alerta('Erro ao enviar lance', 'is-danger');
          });
      } else if (this.auctionSituation === SituacaoEnum.PREFERENCIA) {
        await enviarPreferencia(this.auction.id, mappedBids)
          .then(data => {
            if (data.data.length === 1) {
              this.$alerta('Preferência Enviada', 'is-info', 1000);
            } else if (data.data.length > 1) {
              this.$alerta('Preferências Enviadas', 'is-info', 1000);
            }
            this.adicionarLancesEmpresa(data.data);
            if (this.openItem) this.focusValueInput();
          })
          .catch(error => {
            if (error.response && Array.isArray(error.response.data.error)) {
              const outOfTime = error.response.data.error.some(
                element => element.status === 'ForaDoPrazo',
              );

              if (outOfTime) {
                this.$alerta('Tempo finalizado', 'is-danger');
                return;
              }
            }
            this.$alerta('Erro ao enviar preferência', 'is-danger');
          });
      } else if (
        [SituacaoEnum.NEGOCIACAO, SituacaoEnum.JULGAMENTO].includes(this.auctionSituation)
      ) {
        await enviarLanceNegociacao(this.auction.id, mappedBids)
          .then(data => {
            const proposta = data.data;
            if (proposta.length === 1) {
              this.$alerta('Proposta Enviada', 'is-info');
            } else if (proposta.length > 1) {
              this.$alerta('Propostas Enviadas', 'is-info');
            }
            this.adicionarLancesEmpresa(proposta);
            if (this.openItem) this.focusValueInput();
          })
          .catch(() => {
            this.$alerta('Erro ao enviar proposta', 'is-danger');
          });
      }

      this.bids = [];
      this.cleanFields();
      this.loading.general = false;
    },
    async handleDeclarationsConfirm(payload = {}) {
      await this.createDeclaration('requirements', true);

      if (payload.regionalPreference === true) {
        await this.createDeclaration('regionalPreference', true);
      }

      this.declarationsModal = false;
      this.declarationsModalShown = true;
      if (this.pendingSendBids) {
        this.pendingSendBids = false;
        this.executeSendBids();
      }
    },
    cancelDeclarations() {
      this.declarationsModal = false;
      this.pendingSendBids = false;
      this.displayConfirmation.offer = false;
    },
    selectProposalKey(itemId) {
      if (['delete', 'import'].indexOf(this.mode) > -1) return this.componentKey;
      return itemId;
    },
    verifyPIN(itemId, itemIdentifier, itemDescription, itemUnity) {
      this.abdicatePreferenceData = { itemId, itemIdentifier, itemDescription, itemUnity };
      if (!this.validPin) {
        this.preferenceAbdicatePin = true;
        this.reasonPIN = 'PREGAO-ABDICAR-PREFERENCIA';
        this.preferenceConfirmationModal = true;
      } else {
        this.mountPreferenceConfirmation();
      }
    },
    viewAllItems() {
      this.$emit('view-all-items');
    },
    hasItemOptionsMenu(row) {
      const flags = this.itemUiFlags[row.id];

      return (
        (flags && (flags.showOffers || flags.canDeleteBid)) ||
        this.displayAppealIntentionButton ||
        this.displaySendJudgmentDiligence(row)
      );
    },
    displaySendJudgmentDiligence(row) {
      if (!this.bidder || !this.displayJudgmentDiligenceStage || row.estado !== 'JULGAMENTO') {
        return false;
      }

      const diligence = this.activeDiligenceForItemBidder(row.id, this.userLoggedBidder?.id);

      return diligence && row.menor_lance?.fornecedor_id === this.userLoggedBidder?.id;
    },
    openJudgmentDiligenceUpload(row) {
      const diligence = this.activeDiligenceForItemBidder(row.id, this.userLoggedBidder.id);
      if (!diligence) return;

      this.$emitBus('judgment-diligence-upload', {
        item: row,
        diligence,
        company: {
          alias: this.userLoggedBidder.alias,
          bidderId: this.userLoggedBidder.id,
          socialDenomination: this.company.socialDenomination,
        },
      });
    },
    async refreshJudgmentDiligences() {
      if (!this.auction?.id || !this.displayJudgmentDiligenceStage) return;

      await Promise.all([
        this.fetchJudgmentDiligences({ auctionId: this.auction.id, activeOnly: true }),
        this.fetchUnresolvedJudgmentDiligences({ auctionId: this.auction.id }),
      ]);
    },
    verifySituation(auctionSituation) {
      return this.auction.situacao.id === auctionSituation;
    },
    displayBatchButton() {
      return this.batchButtonEnabled;
    },
    classificarPropostasItens() {
      this.loading.classificarItens = true;
      this.justificar = true;
    },
    async classificarPropostas({ justification, state }) {
      // eslint-disable-next-line camelcase
      const itens = this.selectedItems.map(item => item.id);
      const classificacao = {
        justificativa: justification || 'Classificada.',
        estado: state === 'success' ? 'CLASSIFICADA' : 'DESCLASSIFICADA',
      };
      await this.classificarItens({ itens, classificacao });
      this.$alerta(
        `Propostas ${state === 'success' ? 'classificadas' : 'desclassificadas'} com sucesso`,
        'is-success',
      );
      this.loading.classificarItens = false;
      this.selectedItems = [];
      this.$refs.justificationModal.close();
    },
    checkableItems(item) {
      return (
        (item.estado === 'CADASTRADA' || item.estado === 'HABILITACAO-ENCERRADA') &&
        item.propostasAClassificar
      );
    },
    refreshDescriptionOverflow() {
      this.$nextTick(() => {
        const overflowById = {};

        this.itemsToShow.forEach(item => {
          const containerRef = this.$refs[`description-container-${item.id}`];
          const container = Array.isArray(containerRef) ? containerRef[0] : containerRef;
          if (!container || !container.parentElement) {
            return;
          }

          overflowById[item.id] = container.scrollWidth >= container.parentElement.scrollWidth;
        });

        this.descriptionOverflowById = overflowById;
      });
    },
    scheduleDescriptionOverflowRefresh() {
      if (this.descriptionOverflowTimeout) {
        clearTimeout(this.descriptionOverflowTimeout);
      }

      this.descriptionOverflowTimeout = setTimeout(() => {
        this.refreshDescriptionOverflow();
      }, 120);
    },
    syncDetailRows() {
      const visibleIds = new Set(this.itemsToShow.map(item => item.id));
      this.detailsList = this.detailsList.filter(itemId => visibleIds.has(itemId));
    },
    hasActiveDeleteWindow() {
      if (this.userLoggedBidder && this.userLoggedBidder.excluiuLance) {
        return false;
      }

      const threshold = this.deleteBidNow - 15000;
      return this.itemsToShow.some(item => {
        const latestTimestamp = this.bidsByItemTimestamp[item.id];
        return !!latestTimestamp && latestTimestamp > threshold;
      });
    },
    syncDeleteBidTimer() {
      const shouldRun = this.hasActiveDeleteWindow();

      if (!shouldRun && this.deleteBidTimer) {
        clearInterval(this.deleteBidTimer);
        this.deleteBidTimer = null;
        return;
      }

      if (shouldRun && !this.deleteBidTimer) {
        this.deleteBidTimer = setInterval(() => {
          this.deleteBidNow = Date.now();
          if (!this.hasActiveDeleteWindow() && this.deleteBidTimer) {
            clearInterval(this.deleteBidTimer);
            this.deleteBidTimer = null;
          }
        }, 1000);
      }
    },
  },
  async mounted() {
    await this.getCompanyCredits(this.company.id);
    await this.getCompanyCurrentBillingMethod(this.company.id);
    await this.fetchAppealIntention();
    await this.refreshJudgmentDiligences();
    this.auctionType = getOfertaCompraEnum(this.auction.tipo).titleSingular;

    this.$nextTick(() => {
      if (this.bidder) {
        this.focusValueInput();
      }
      this.refreshDescriptionOverflow();
      this.syncDeleteBidTimer();
    });
    window.addEventListener('resize', this.scheduleDescriptionOverflowRefresh);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.scheduleDescriptionOverflowRefresh);
    if (this.descriptionOverflowTimeout) {
      clearTimeout(this.descriptionOverflowTimeout);
      this.descriptionOverflowTimeout = null;
    }
    if (this.deleteBidTimer) {
      clearInterval(this.deleteBidTimer);
      this.deleteBidTimer = null;
    }
  },
};
</script>

<style lang="scss" scoped>
.all-items-button-container {
  width: 25%;
}

.check-regional-preference {
  margin-top: 1rem;
  margin-left: unset !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}

.footer-container {
  display: flex;
  margin-top: 0.5rem;
  width: 100%;
}

.options-button {
  font-size: 0.9rem;
}

::v-deep .items-table td.options-column {
  overflow: visible;
}

.appeal-intention-button {
  padding-left: 0.6rem;
  padding-right: 0.6rem;
}

.terms {
  padding: 15px;
  margin-bottom: 1rem;
  border: 1px solid rgba(0, 0, 0, 0.1);
  display: inline-block;
  max-width: 1150px;
}

.tm-1 {
  margin-top: 1rem;
}

.send-button-container {
  width: 25%;
}

.value-warning-container {
  width: 50%;
}

@media (max-width: 768px) {
  .value-warning {
    font-size: 0.7rem;
  }
}
</style>

<style lang="scss">
.custom-eye-icon .mdi-eye-outline::before {
  font-size: 22px;
}

.auction-items-table .table-wrapper .table {
  max-width: 99.8%;
}

@media (min-width: 769px) {
  .elipsis-size {
    max-width: 1px;
    width: 100%;
  }
}
</style>

<style lang="scss">
#my-items-options-field .field-body .field {
  justify-content: center !important;
}
</style>

<style src="@/styles/items.scss" lang="scss" scoped />
